var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaiting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9718 6.25428V0.629013C19.9718 0.281483 19.6903 0 19.3428 0H5.819C5.47147 0 5.18999 0.281483 5.18999 0.629013V6.25428C5.18999 6.39895 5.23968 6.53922 5.3312 6.65119L9.17888 11.3807L8.0542 12.7473C7.37204 12.4674 6.62665 12.3104 5.84479 12.3104C2.62173 12.3104 0 14.9325 0 18.1552C0 21.378 2.62173 24 5.84448 24C7.26447 24 8.56716 23.4899 9.58113 22.6445H19.3428C19.6903 22.6445 19.9718 22.363 19.9718 22.0155V16.4525C19.9718 16.3065 19.9212 16.1653 19.8284 16.0527L15.9832 11.3807L19.8309 6.65119C19.9218 6.53922 19.9718 6.39895 19.9718 6.25428ZM1.57253 18.1552C1.57253 15.7996 3.48914 13.883 5.84448 13.883C8.19982 13.883 10.1164 15.7996 10.1164 18.1552C10.1164 20.5109 8.19982 22.4275 5.84448 22.4275C3.48914 22.4275 1.57253 20.5109 1.57253 18.1552ZM18.3993 5.91901L14.1135 11.1867C14.0191 11.3027 14.0194 11.4694 14.1147 11.5852L18.3993 16.7912V21.0723H10.9017C11.3996 20.2127 11.6893 19.2182 11.6893 18.1555C11.6893 16.2845 10.802 14.6205 9.43017 13.5499L11.047 11.5855C11.142 11.4701 11.1427 11.3034 11.0483 11.187L6.76252 5.91901V1.57253H18.3993V5.91901Z",
    fill: "#858585"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaiting);
export default __webpack_public_path__ + "static/media/waiting.4bc1fd719117ca4d333a95f4d48e024b.svg";
export { ForwardRef as ReactComponent };